module.exports = __webpack_public_path__ + "static/media/make-money-v3.e07ff63b.png";